import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import HeaderMidSeason from "../components/Header-MidSeason";
import { MID_SEASON_MODE } from "../data/globalConstants";

export default function MainLayout() {
  return (
    <div>
      {!MID_SEASON_MODE ? <Header /> : <HeaderMidSeason />}
      <Outlet />
    </div>
  );
}
